<template>
  <div class="page">
    <div class="header">
      <div class="top">
        <span
          class="back"
          @click="backHome"
        >返回首页</span>
      </div>
      <div class="info">
        <div class="title">普通提现, 等待申请中…</div>
        <p>预计等待20天</p>
      </div>
      <div class="status-banner">
        <div class="title">{{detail.applyAmount}}元/{{detail.dueTime}}期</div>
        <p>根据您的资质评估，预计提现通过率 <span class="red">1%-5%</span></p>
      </div>
      <div class="buy-container">

        <div
          class="buy-button"
          @click="buyButtonAction"
          data-sensors-click
        >
          <span class="ui-bubble" v-if="expireDate && (expireDate - new Date().getTime() >0) ">
            <van-count-down
              :time="expireDate - new Date().getTime()"
              format="DD天HH时mm分"
            />后涨价
          </span>
          <div class="real-price">
            免审拿钱 ¥{{ discountPrice }}
          </div>
          <div class="origin-price">
            原价 ¥{{ originalPrice }}
          </div>
        </div>
        <div class="protocol">
          开通即同意<span @click="toProtocol">《会员用户协议》</span>
        </div>
      </div>
    </div>

    <version-tips v-model="showVersionTips" />

  </div>
</template>

<script>
import { CountDown } from 'vant'
import { mapActions } from 'vuex'
import { isAndroid, versionStringCompare, getKey } from '@/assets/utils'
import { hasNativeMethod } from '../../assets/jsBridge'
import { WHPay } from '@/assets/buyVip'
// withdraw/result3
export default {
  name: 'withdraw-result',
  components: {
    CountDown,
    'pass-card-dialog': () => import('@/components/pass-card-dialog')
  },
  data () {
    return {
      showVersionTips: false,
      detail: {},
      discountPrice: 0, // 优惠价格
      originalPrice: 0, // 原价
      expireDate: 0
    }
  },
  async created () {
    this.info()
    this.getMemberInfo()
    this.passDirectMarkTag()
    this.$bus.$emit('ready')
  },
  computed: {
    countdownVisible () {
      return this.countDownSeconds > 0
    }
  },
  methods: {
    ...mapActions('withdraw', ['getLoanResultX', 'passDirectMarkTag']),
    ...mapActions('vip', ['memberShipDetail']),
    buy () {
      WHPay(true)
    },
    async getMemberInfo () {
      const res = await this.memberShipDetail({
        memberGoods: 'PSC_M'
      })
      if (res.success) {
        this.discountPrice = res.data.memberGoods.discountPrice || 0
        this.originalPrice = res.data.memberGoods.price || 0
        this.expireDate = res.data.memberGoods.expireDate
      }
    },
    async info () {
      const { success, data } = await this.getLoanResultX({
        loanApplyNo: this.$route.query.loanApplyNo,
        retentionLoanQuery: true
      })
      if (success) {
        this.detail = data || {}
      }
    },

    showVersionTipsDiff () {
      return (
        isAndroid() &&
        hasNativeMethod('getUserInfo') &&
        getKey('appVersion') &&
        versionStringCompare('1.8.1.1', getKey('appVersion')) > 0
      )
    },
    dialogBuyAction () {
      if (this.showVersionTipsDiff()) {
        this.$message('升级最新版本享受免审额度')
      } else {
        this.buy()
      }
    },
    async buyButtonAction () {
      if (this.showVersionTipsDiff()) {
        this.showVersionTips = true
      } else {
        this.buy()
      }
    },
    toProtocol () {
      this.$router.push('/protocol/vip-wh')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page {
  background: #f7f7f7;
  padding-bottom: 50px;
  .red {
    color: #ff3333;
  }
  .ui-bubble {
    background: rgba(0,0,0,0.8);
    border-radius: 20px 20px 20px 0px;
    color: #fff;
    font-size: 20px;
    padding: 4px 20px;
    position: absolute;
    left: 44%;
    top: -25px;
    display: flex;
    height: 44px;
    align-items: center;
    .van-count-down {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      line-height: 33px;
    }
  }
  .header {
    width: 750px;
    height: 340px;
    background: url("./image/bg@2x.png") no-repeat left bottom;
    background-size: 100% 440px;
    padding: 30px;
    .info {
      margin-top: 100px;
      .title {
        font-size: 36px;
        font-family: PingFangTC-Medium, PingFangTC;
        font-weight: 500;
        color: #ffffff;
        line-height: 50px;
        height: 50px;
        background: url(./image/img_dengdai@2x.png) no-repeat 0 6px;
        background-size: 40px 40px;
        padding-left: 50px;
      }
      p {
        height: 40px;
        font-size: 28px;
        font-family: PingFangTC-Medium, PingFangTC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
        padding-left: 50px;
      }
    }

    .back {
      float: right;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      text-decoration: underline;
      text-align: right;
      padding: 30px 0;
    }
    .status-banner {
      width: 690px;
      height: 147px;
      background: #ffffff;
      box-shadow: 0px 10px 20px 0px rgba(211, 211, 211, 0.5);
      border-radius: 20px;
      position: relative;
      margin-top: 30px;
      padding: 30px;
      &::before {
        // 三角形
        content: "";
        position: absolute;
        top: -30px;
        left: 100px;
        border-width: 16px;
        border-style: solid;
        border-color: transparent transparent #ffffff transparent;
      }
      .title {
        font-size: 36px;
        font-family: PingFangTC-Medium, PingFangTC;
        font-weight: 500;
        color: #333333;
        line-height: 56px;
      }
      p {
        font-size: 24px;
        font-family: PingFangTC-Regular, PingFangTC;
        font-weight: 400;
        color: #999999;
        line-height: 33px;
      }
    }
  }

  .buy-container {
    width: 690px;
    height: 920px;
    background: #fff url("./image/img_pass@.png") no-repeat;
    background-size: 100% 920px;
    box-shadow: 0px 10px 20px 0px rgba(211, 211, 211, 0.5);
    border-radius: 20px;
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 620px;
    .buy-button {
      width: 650px;
      height: 88px;
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      border-radius: 47px;
      margin-top: 40px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
      .real-price {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;
        line-height: 45px;
        margin-right: 24px;
      }
      .origin-price {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        opacity: 0.6;
        color: #fff;
        line-height: 34px;
        text-decoration: line-through;
      }
    }
    .protocol {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      line-height: 33px;
      margin-top: 20px;
      span {
        color: #8EB2D8;
      }
    }
  }
}
</style>